// ponytail: bridges the pre-Aurora `fq=`/`page=` URL scheme to Aurora's `f_`/`start`
// scheme so ~200 external links keep working. Remove this file and its one call site
// (create-listing-state.svelte.ts) once those URLs are no longer in use — see WEB-1123.

const RANGE_FIELDS = new Set(["price"]);

export function migrateLegacyUrl(rows: number): void {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("fq") && !params.has("page")) return;

  for (const raw of params.getAll("fq")) {
    const separatorIndex = raw.indexOf(":");
    if (separatorIndex === -1) continue;
    const field = raw.slice(0, separatorIndex);
    const values = raw.slice(separatorIndex + 1).split(",");
    if (RANGE_FIELDS.has(field) && values.length === 2) {
      params.append(`f_${field}`, values.join(","));
    } else {
      for (const value of values) params.append(`f_${field}`, value);
    }
  }
  params.delete("fq");

  const page = parseInt(params.get("page") ?? "", 10);
  if (page > 1) params.set("start", String((page - 1) * rows));
  params.delete("page");

  const sort = params.get("sort");
  if (sort?.includes("+")) params.set("sort", sort.replace(/\+/g, " "));

  const search = params.toString();
  history.replaceState(null, "", `${location.pathname}${search ? `?${search}` : ""}`);
}
